module.exports = new __parcel__URL__("Luke_FI_valk_RGB.c0d8fd94.png").toString();